import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../context/AuthContext";
import useApiV2, {
  CINCO_MINUTOS,
  repetirSoErroDeServidor,
} from "../utils/useApiV2";

export default function useQueueV2({ branchId, start, end, enabled = true }) {
  const { getQueueMetrics } = useApiV2();
  const { user } = useAuth();

  return useQuery({
    queryKey: ["queueV2", user?.user_id ?? null, branchId, start, end],
    queryFn: () => getQueueMetrics({ branch_id: branchId, start, end }),
    enabled: Boolean(enabled && branchId && start && end),
    staleTime: CINCO_MINUTOS,
    retry: repetirSoErroDeServidor,
  });
}
